const parsedPublicOrgId = Number(process.env.REACT_APP_PUBLIC_ORG_ID || '1');

const config = {
  apiBaseUrl: process.env.REACT_APP_API_URL || 
    (process.env.NODE_ENV === 'production' 
      ? "https://exammastersapi.terasite.com" 
      : "https://localhost:7298"),
  publicOrgSlug: (process.env.REACT_APP_PUBLIC_ORG_SLUG || 'em').trim().toLowerCase(),
  publicOrgId: Number.isFinite(parsedPublicOrgId) && parsedPublicOrgId > 0 ? parsedPublicOrgId : 1,
  publicOrgLegacySlugs: (process.env.REACT_APP_PUBLIC_ORG_LEGACY_SLUGS || 'exammasters')
    .split(',')
    .map((slug) => slug.trim().toLowerCase())
    .filter((slug) => slug.length > 0),
  
  // Site Page Info API Configuration https://localhost:7298
  sitePageInfoApi: {
    baseUrl: process.env.REACT_APP_SITE_PAGE_API_URL || 'https://contentreader.terasite.com',
    siteId: process.env.REACT_APP_SITE_ID || '97',
    endpoint: '/api/SitePageInfo/getDetailsList'
  }
};

// Helper function to build site page info API URLs
export const buildSitePageInfoUrl = (pageType: string) => {
  const url = new URL(config.sitePageInfoApi.endpoint, config.sitePageInfoApi.baseUrl);
  url.searchParams.append('pageType', pageType);
  return url.toString();
};

// Helper function to build site page detail URL by pagenav
export const buildSitePageInfoByNavUrl = (pagenav: string) => {
  const safeNav = encodeURIComponent(pagenav.trim());
  return new URL(`/api/SitePageInfo/getDetailsFromNav/${safeNav}`, config.sitePageInfoApi.baseUrl).toString();
};

// Helper function to get site page info headers
export const getSitePageInfoHeaders = () => ({
  'Content-Type': 'application/json',
  'X-SiteId': config.sitePageInfoApi.siteId
});

export default config;
